export default {
    it: {
        "yes.text": "Si",
        "no.text": "No",
        "appointment.text": "Voglio prenotare un appuntamento",
        "contact.text": "Voglio essere ricontattato",
        "compilaform.text": "Compila il form",
    },
    en: {
        "yes.text": "Yes",
        "no.text": "No",
        "appointment.text": "I want to book an appointment",
        "contact.text": "I want to be contacted",
        "compilaform.text": "Fill out the form",

    }
}